import { FW } from './../framework/Framework';
import { ObjectBase } from './../framework/ObjectBase';
import { userRecord } from '../data/UserRecord';

declare var postRobot: any;

export class IframeObject extends ObjectBase {

    public iframe: HTMLIFrameElement;

    constructor() {
        super();

        this.iframe = document.createElement("iframe");

    }

    public start(src: string, recordCallback: (recordJson:Object) => void): Promise<any> {
        return new Promise<any>((resolve, _reject) => {
            this.iframe.setAttribute('src', src);
            document.body.appendChild(this.iframe);

            var listener = postRobot.listener({ window: this.iframe.contentWindow, domain: '*' });
            listener.on('closeGame', event => {
                this.delayClose();
                userRecord.refresh();
                resolve(event.data.nextLevel);
            });
            listener.on('gameResult', event => {
                userRecord.refresh();
                recordCallback(event.data.record);
            });
            listener.on('gameInited', _event => {
                this.iframe.contentWindow.focus();
            });
        });
    }

    private delayClose():void {
        this.iframe.style.visibility = 'hidden';
        FW.addDelayFunction(null, () => {
            this.dispose();
        }, null, 500);
    }

    public setDimension(x: any, y: any, width: any, height: any): void {
        this.iframe.setAttribute('style', 'position:fixed;top:' + x + 'px;left:' + y + 'px');
        this.iframe.setAttribute('width', width);
        this.iframe.setAttribute('height', height);
    }

    public dispose(): void {
        if (this.iframe) {
            document.body.removeChild(this.iframe);
            this.iframe = null;
        }
        super.dispose();
    }
}


// WEBPACK FOOTER //
// ./src/worlds/IframeObject.ts